// extracted by mini-css-extract-plugin
export default {"tabList":"tabList--UYhDP","tabItem":"tabItem--h6Qzs","tab":"tab--hHR7l","selected":"selected--VTpcY"};